var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCloseIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.13867 15.3472C4.0166 15.2251 3.93604 15.0835 3.89697 14.9224C3.85791 14.7612 3.85791 14.6001 3.89697 14.439C3.93604 14.2778 4.01416 14.1387 4.13135 14.0215L8.49658 9.64893L4.13135 5.28369C4.01416 5.17139 3.93604 5.03467 3.89697 4.87354C3.86279 4.70752 3.86279 4.54395 3.89697 4.38281C3.93604 4.22168 4.0166 4.08008 4.13867 3.95801C4.25586 3.83594 4.39502 3.75537 4.55615 3.71631C4.72217 3.67725 4.88574 3.67725 5.04688 3.71631C5.21289 3.75537 5.35449 3.8335 5.47168 3.95068L9.83691 8.31592L14.2021 3.95068C14.3193 3.8335 14.4585 3.75537 14.6196 3.71631C14.7808 3.67725 14.9419 3.67725 15.103 3.71631C15.2642 3.75537 15.4058 3.83838 15.5278 3.96533C15.6499 4.08252 15.7305 4.22168 15.7695 4.38281C15.8135 4.54395 15.8135 4.70508 15.7695 4.86621C15.7305 5.02734 15.6523 5.1665 15.5352 5.28369L11.1772 9.64893L15.5352 14.0215C15.6523 14.1387 15.7305 14.2778 15.7695 14.439C15.8086 14.6001 15.8086 14.7612 15.7695 14.9224C15.7305 15.0835 15.6499 15.2251 15.5278 15.3472C15.4058 15.4692 15.2642 15.5498 15.103 15.5889C14.9419 15.6279 14.7808 15.6279 14.6196 15.5889C14.4585 15.5498 14.3193 15.4717 14.2021 15.3545L9.83691 10.9893L5.47168 15.3545C5.35449 15.4717 5.21533 15.5498 5.0542 15.5889C4.89307 15.6279 4.72949 15.6279 4.56348 15.5889C4.40234 15.5498 4.26074 15.4692 4.13867 15.3472Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCloseIcons);
export default __webpack_public_path__ + "static/media/WebCloseIcons.1d571e71d47c97e8b0f641966d509260.svg";
export { ForwardRef as ReactComponent };